// Module
var code = "<flows-todo-group class=\"flows-todo-groups\" ng-repeat=\"group in $ctrl.groups\" group=\"group\" groups=\"$ctrl.groups\" is-mobile=\"$ctrl.isMobile\"></flows-todo-group> ";
// Exports
export default code;